import React from 'react'

const DeanDashboard = () => {
  return (
    <div>DeanDashboard</div>
  )
}

export default DeanDashboard